import { render, staticRenderFns } from "./SelectMainSubCategory.vue?vue&type=template&id=21304ad2"
import script from "./SelectMainSubCategory.vue?vue&type=script&lang=ts"
export * from "./SelectMainSubCategory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports